import React, { useState, useEffect, useRef } from "react";
import { OuterContainer } from "../../EventCreation/styles";
import ActionBar from "../../common/ActionBar";
import styled from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import CustomTable from "../../common/CustomTable/MaterialCustomTable";
import CardCount from "../../common/CardCount";
import { useSnackbar } from "notistack";
import EventService from "../../../services/EventService";
import { getErrorMessage } from "../../../helpers/functions";
import { navigate } from "@reach/router";
import Template from "../Template";
import ReasonForCancel from "../ReasonForCancel";
import { Tooltip, makeStyles } from "@material-ui/core";
import _ from "lodash";
import HostService from "../../../services/HostService";
import EmailSender from "../PreviewModal";
import useUser from "../../../hooks/useUser";
import useStatus from "../../../hooks/useStatus";

const useStyles = makeStyles((theme) => ({
  customTooltip: {
    color: "#ffffff",
    fontSize: "12px",
    borderRadius: "8px",
    fontFamily: "openSans-SemiBold, sans-serif",
  },
}));

const Home = () => {
  const [state, setState] = useState();
  const MTRef = useRef();
  const [selectedFilter, setSelectedFilter] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState();
  const [modal, setModal] = useState({ state: false });
  const [cancelModal, setCancelModal] = useState({ state: false });
  const [trigger, setTrigger] = useState(true);
  const classes = useStyles();
  const [previewModal, setPreviewModal] = useState({ state: false });
  const { userObject } = useUser();
  const { setGlobalId } = useStatus();

  useEffect(() => {
    async function getEventMetricsEventsList() {
      try {
        const payload = {
          role: "eventManager",
        };
        const response = await EventService.getEventMetricsEventsList(payload);
        if (response) {
          setCount(response?.counts);
        }
      } catch (err) {
        const message = getErrorMessage(err);
        enqueueSnackbar(message, {
          variant: "error",
        });
      }
    }
    getEventMetricsEventsList(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dashboardCount = {
    todaysEvent: count?.allTodayEventsCount,
    compltedEvents: count?.allPastEventsCount,
    upcomingEvents: count?.allFutureEventsCount,
    activeCustomers: count?.activeUsersCount,
    averageParticipants: count?.averageParticipantsCount,
    registeredUsers: count?.allUserEventViewersCount,
    liveInteractions: count?.allLiveInteractionsCount,
  };

  const badges = [
    {
      value: count?.allTodayEventsCount,
      label: "Today's Events",
      key: "todaysEvent",
    },
    {
      value: count?.allPastEventsCount,
      label: "Completed Events",
      key: "compltedEvents",
    },
    {
      value: count?.allFutureEventsCount,
      label: "Upcoming Events",
      key: "upcomingEvents",
    },
    {
      value: count?.activeUsersCount,
      label: "Active Customers",
      key: "activeCustomers",
    },
    {
      value: count?.averageParticipantsCount,
      label: "Average Participants",
      key: "averageParticipants",
    },
    {
      value: count?.allUserEventViewersCount,
      label: "Registered Users",
      key: "registeredUsers",
    },
    {
      value: count?.allLiveInteractionsCount,
      label: "Live Interactions",
      key: "liveInteractions",
    },
  ];

  function formatTime(time) {
    const [hours, minutes] = time.split(":");
    const date = new Date();
    date.setHours(hours, minutes);

    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  const columns = [
    {
      field: "eventId",
      title: "Event ID",
      sorting: true,
      render: (rowData) => (
        <HyperLink
          isStriked={rowData?.eventStatus === "cancelled"}
          onClick={() =>
            navigate(
              `/dashboard/eventmanager/question-and-answer/${rowData?.eventId}`,
            )
          }
        >
          {rowData?.eventId}
        </HyperLink>
      ),
      width: 90,
    },
    {
      field: "eventName",
      title: "Event Name",
      render: (rowData) => (
        <Tooltip
          title={rowData?.eventName}
          placement="top"
          arrow
          classes={{
            tooltip: classes.customTooltip,
          }}
        >
          <HyperLink
            width={rowData?.eventName?.length > 30 ? "210px" : "auto"}
            isStriked={rowData?.eventStatus === "cancelled"}
            onClick={() =>
              rowData?.eventUrl &&
              !rowData?.playbackInfo?.playbackRequired &&
              rowData?.eventStatus === "inactive"
                ? enqueueSnackbar(
                    "Event status is Inactive / Playback info is disabled",
                    {
                      variant: "error",
                    },
                  )
                : window.open(rowData?.eventUrl)
            }
          >
            {rowData.eventName}
          </HyperLink>
        </Tooltip>
      ),
      width: 250,
    },
    {
      field: "eventTemplate",
      title: "Type",
      render: (rowData) => (
        <Center isStriked={rowData?.eventStatus === "cancelled"}>
          {rowData.eventTemplate ? _.startCase(rowData.eventTemplate) : "-"}
        </Center>
      ),
      width: 140,
    },
    // {
    //   field: "eventStatus",
    //   title: "Status",
    //   render: (rowData) => (
    //     <Center isStriked={rowData?.eventStatus === "cancelled"}>
    //       {_.startCase(rowData.eventStatus)}
    //     </Center>
    //   ),
    //   width: 100,
    // },
    {
      field: "orgName",
      title: "Company",
      render: (rowData) => (
        <Tooltip
          title={rowData?.orgName}
          placement="top"
          arrow
          classes={{
            tooltip: classes.customTooltip,
          }}
        >
          <Center
            width={rowData?.orgName?.length > 8 ? "90px" : "auto"}
            isStriked={rowData?.eventStatus === "cancelled"}
          >
            {rowData.orgName ? rowData.orgName : "-"}
          </Center>
        </Tooltip>
      ),
      width: 90,
    },
    {
      field: "coordinatorName",
      title: "Coordinator",
      render: (rowData) => (
        <Tooltip
          title={
            <React.Fragment>
              <div>
                Phone Number: {rowData?.coordinatorInfo?.coordinatorphone}
              </div>
              <div>Email Id: {rowData?.coordinatorInfo?.coordinatorEmail}</div>
            </React.Fragment>
          }
          placement="top"
          arrow
          classes={{
            tooltip: classes.customTooltip,
          }}
        >
          <Center isStriked={rowData?.eventStatus === "cancelled"}>
            {rowData?.coordinatorName ? rowData?.coordinatorName : "-"}
          </Center>
        </Tooltip>
      ),
      width: 150,
    },
    {
      field: "eventDate",
      title: "Date",
      render: (rowData) => (
        <Center isStriked={rowData?.eventStatus === "cancelled"}>
          {rowData.eventDate}
        </Center>
      ),
      // sorting: true,
      width: 100,
    },
    {
      field: "eventTime",
      title: "Time",
      render: (rowData) => (
        <Center isStriked={rowData?.eventStatus === "cancelled"}>
          {rowData?.eventTime ? formatTime(rowData?.eventTime) : "-"}
        </Center>
      ),
      // sorting: true,
      width: 100,
    },
    {
      field: "action",
      title: "Action",
      render: (rowData) => (
        <div
          style={{
            display: "flex",
            pointerEvents: rowData?.eventStatus === "cancelled" && "none",
          }}
        >
          <HyperLink
            isStriked={rowData?.eventStatus === "cancelled"}
            onClick={() => {
              setGlobalId(rowData?.eventId);
              navigate(`/dashboard/eventmanager/preview/${rowData?.eventId}`, {
                state: {
                  communicateTab: rowData?.livePageSettings?.communicateTab,
                  eventId: rowData?.eventId,
                  rowData: {
                    ...rowData,
                    eventManageName:
                      userObject?.firstName + userObject?.lastName,
                  },
                },
              });
            }}
          >
            View
          </HyperLink>{" "}
          <HyperLink
            isStriked={rowData?.eventStatus === "cancelled"}
            style={{ marginLeft: "5px" }}
            onClick={() => {
              setGlobalId(rowData?.eventId);
              navigate(
                `/dashboard/eventmanager/event-details/${rowData?.eventId}`,
                {
                  state: {
                    communicateTab: rowData?.livePageSettings?.communicateTab,
                  },
                },
              );
            }}
          >
            Manage
          </HyperLink>{" "}
          {rowData?.eventStatus !== "cancelled" ? (
            <HyperLink
              isStriked={rowData?.eventStatus === "cancelled"}
              style={{ marginLeft: "5px" }}
              onClick={() => setCancelModal({ state: true, rowData: rowData })}
            >
              Cancel
            </HyperLink>
          ) : null}
          <HyperLink
            isStriked={rowData?.eventStatus === "cancelled"}
            style={{ marginLeft: "5px" }}
            onClick={() => setModal({ state: true, rowData: rowData })}
          >
            Copy
          </HyperLink>
        </div>
      ),
      width: 270,
    },
  ];

  useEffect(() => {
    async function getOrganizationData() {
      try {
        const response = await EventService.getEventInfo();
        const hostResponse = await HostService.activeOrganisation();

        const newArray = response?.map((item) => ({
          ...item,
          coordinatorName: item?.coordinatorInfo?.coordinatorName,
          orgName: hostResponse?.organizations?.filter(
            (arr) => arr?.orgId === parseInt(item?.orgId),
          )[0]?.orgName,
        }));
        setState({ data: newArray });
      } catch (error) {
        setState({ data: [] });
        const message = getErrorMessage(error);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoading(false);
        setTrigger(false);
      }
    }
    if (trigger) {
      getOrganizationData();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger]);

  return (
    <OuterContainer disabled={false}>
      <ActionBar breadcrumbs={["Event Manager", "Manage Organizations"]} />
      <CardCount dashboardCount={dashboardCount} cards={badges} />
      <Padding>
        <CustomTable
          hidePagination={state?.lastPage === 1}
          pageSize={state?.length ? state?.length : 10}
          pluralTitle={"Events"}
          singularTitle={"Events"}
          placeholderText={"Search"}
          noToolbar={true}
          {...{
            columns,
            selectedFilter,
            setSelectedFilter,
            MTRef,
          }}
          loading={loading}
          data={state?.data}
          hideFilterBar
          state={state}
        />
      </Padding>
      {modal?.state && <Template {...{ modal, setModal, setTrigger }} />}
      {cancelModal?.state && (
        <ReasonForCancel {...{ cancelModal, setCancelModal, setTrigger }} />
      )}
      {previewModal?.state && (
        <EmailSender {...{ previewModal, setPreviewModal }} />
      )}
    </OuterContainer>
  );
};

export default Home;

const Center = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: #454545;
  position: relative;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: ${({ width }) => width};
  ${({ isStriked, strikeColor = "red" }) =>
    isStriked &&
    `
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: ${strikeColor};
        transform: translateY(-50%);
      }
    `}
`;

export const HyperLink = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: ${COLORS.LIGHT_BLUE_LABEL};
  text-decoration: ${({ isStriked }) => (isStriked ? "none" : "underline")};
  cursor: pointer;
  position: relative;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: ${({ width }) => width};
  ${({ isStriked, strikeColor = "red" }) =>
    isStriked &&
    `
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: ${strikeColor};
        transform: translateY(-50%);
      }
    `}
`;

const Padding = styled.div`
  padding: 30.3px 15px 15.7px 15px;
  @media ${theme?.breakpoints?.sm_up} {
    padding-top: 30px;
    padding-bottom: 50px;
    padding-left: 35px;
    padding-right: 53px;
  }
`;
